<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
 MEMBER CENTER                              </p>
	</div>
   <div class="mem-full">
 <Center title='1' />
	
<div class="mem-con">
	<div class="mem-jin">
		member center / <b>order management</b>
	</div>
	<div class="ord-not">
		<el-row>
			<el-col span="1">
				<img src="../../assets/not.png">
			</el-col>
			<el-col span="2">
				<div class="dot"> Alert:</div>
			</el-col>
			<el-col span="21">
				<div>The official website is divided into Chinese station and English station. The two versions of points cannot be used interactively. Please choose one version as the only trading platform according to your daily browsing preferences. If you have any questions, please send an email to the customer service staff. </div>
			</el-col>
		</el-row>
		
	</div>
	<div class="cen-ord">
		 <el-tabs v-model="activeName" @tab-click="handleClick">
		    <el-tab-pane label="ALL ORDERS" name="0"></el-tab-pane>
		    <el-tab-pane label="UNPAID" name="1"></el-tab-pane>
		    <el-tab-pane label="GOODS NOT RECEIVED " name="3"></el-tab-pane>
			<el-tab-pane label="COMPLETED" name="4"></el-tab-pane>
		
		  </el-tabs>
		  <div class="cen-ord1">
			  <el-row>
				  <el-col span="11">
product</el-col>
<el-col span="5">  Total order amount  </el-col>
<el-col span="3">  Order status  </el-col>
<el-col span="4">operation  </el-col>
			  </el-row>
		  </div>
		  <div class="address">
		  	<div class="men-l1" v-for="item in news">
		  		<div class="re-tit">
		  				   <h4>order number: {{item.orderId}}</h4><span>{{item.dtTime}}</span>
		  		</div>
		  		<div class="re-con">
					<el-row class="ord-de">
						
									  <el-col span="11" class="ord-de1">
									 <el-row gutter='10' v-for="it in item.products" class="mem-con-it">
											  <el-col span="10">
												  <img class="cen-ord2" :src="it.image" />
											  </el-col>
											  <el-col span="14" class="cen-ord3">
											  		<div>{{it.title}}</div>
													<div>*{{it.num}}</div>
											  </el-col>
										  </el-row>
				</el-col>
					<el-col span="5"><div><p class="ord-price"> $ {{item.price}}</p><p class="ord-gand">PAYPAL payment</p></div> </el-col>
					<el-col span="3">
					<div v-if="item.status==-5" class="h-button" @click="sandRed(item.id)">Payment</div>
					<p v-if="item.status==2">To be delivered</p><p v-if="item.status==3">Goods to be received</p> <p v-if="item.status==4">Goods received

</p> <p v-if="item.status==-1">Cancelled</p>
					<p class="mem-ord-det"><router-link :to="'/user/details?id='+item.id">Order details</router-link></p></el-col>
					<el-col span="4"><div v-if="item.status==3" class="h-button" @click="confirm(item.id)">Confirm receipt</div>
					<!-- <div v-if="item.status==-5" class="h-button but2" @click="cancel(item.id)">Cancel order</div> -->
					<div v-if="item.status==-1||item.status==4" class="h-button but2" @click="del(item.id)">Delete order</div>
	   </el-col>
								  </el-row>
		  		</div>
		  	</div>
	
		  </div>
	</div>
	<div class="language-tip">
		Here are still {{extranet_count}} orders in your Chinese website <a href="http://www.fuelme.com.cn/#/user/orders"><div class="h-button but3">View details</div></a>
		
	</div>

   <div class="page">
	     
	     <el-pagination
	       layout="prev, pager, next"
	       :total="total"
		   @current-change="pick">
	     </el-pagination>
	   </div>
	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center


  },
  data() {
    return {
		page:1,
		pagenum:100,
		moren:false,
		activeName: '0',
		sun:'',
		total:'',
		news:'',
		extranet_count:0,
           ruleForm: {
           	first_name:'',
           	last_name:'',
         
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
			moren: 0,
          
               
                 },
                 rules: {
                 	
                 	   first_name: [
                 	    { required: true, message: 'Please fill in First name', trigger: 'blur' },
                 ],last_name: [
                 	    { required: true, message: 'Please fill in Last name', trigger: 'blur' },
                 ],phone: [
                 	    { required: true, message: 'Please fill in Phone', trigger: 'blur' },
                 ],country: [
                 	    { required: true, message: 'Please fill in Country', trigger: 'change' },
                 ],address_line: [
                 	    { required: true, message: 'Please fill in Address Line 1', trigger: 'blur' },
                 ],province: [
                 	    { required: true, message: 'Please fill in Province', trigger: 'blur' },
                 ],city: [
                 	    { required: true, message: 'Please fill in City', trigger: 'blur' },
                 ],postcode: [
                 	    { required: true, message: 'Please fill in Postcode', trigger: 'blur' },
                 ],nickname: [
                 	    { required: true, message: 'Please fill in nickname', trigger: 'blur' },
                 ],identity_id: [
                 	    { required: true, message: 'Please fill in ID', trigger: 'blur' },
                 ]
                  
                   }
          };
  },  mounted() {
	  
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
		
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=userAddress_add",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					this.$message.success(data.message);
					this.sandMate()
		  
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
			  full(){
				  if(this.moren){
					  this.ruleForm.moren= 1
				  }else{
					   this.ruleForm.moren= 0
				  }
			
			  },
			  confirm(item){
			   	this.$axios({
			   	  method: "post",
			   	  url: "service.php?action=orders_qrshouhuo",
			   	  data: {orderId:item},  
			   	}).then((res) => {
			   		let data=res.data;
			   	
			   		if(data.code==1){
			   			
			   		this.$message.success(data.message);
			
			   		}else{  
			   			this.$message.error(data.message);
			   			      
			   		}
			   	 
			   	});
			   
			   },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },pick(item){
							this.page=item;
							this.sandMate()
						}, sandRed(id){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=paypal_pay",
			  	  data: {order_id:id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  		window.open(data.data.link)
				
			  		}
			  	 
			  	});
			  
			  }, cancel(id){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_qxOrder",
			  	  data: {order_id:id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  			
			  		this.$message.success(data.message);
			  			this.sandMate();		
			  		}else{  
			  			this.$message.error(data.message);
			  			      
			  		}
			  	 
			  	});
			  
			  },del(id){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_del",
			  	  data: {order_id:id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  			
			  		this.$message.success(data.message);
			  			this.sandMate();		
			  		}else{  
			  			this.$message.error(data.message);
			  			      
			  		}
			  	 
			  	});
			  
			  },
			 sandMate(){
			 	this.$axios({
			 	  method: "post",
			 	  url: "service.php?action=orders_lists",
			 	  data: {page:this.page,scene:this.activeName},  
			 	}).then((res) => {
			 		let data=res.data;
			 
			 		if(data.code==1){
			 	
			 							
			 			this.news=data.data;
			 			this.total=data.count
						this.extranet_count=data.extranet_count
			 			
			 		}
			 	 
			 	});
			 
			 },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }, handleClick() {
				  this.sandMate()
      
      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			background: #000;
			color: #FFFFFF;
			margin-right: 30px;

		}
		.h-button:hover{
			background-color: #333333;
		}
		.but2{
			background: #E8E8E8;
			color: #0A0A0A;
		}
		.but3{
			width: 140px;
			background: #E8E8E8;
			color: #0A0A0A;
			margin-left: 20px;
		}
		.but3:hover{
	color: #ffffff;
		}
		.but2:hover{
		
			color: #ffffff;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.address{
	.re-con{
		.ord-gand{
			margin-top: 10px;
			color: #989898;
		}
		.ord-de{
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.ord-de1{
			padding-right: 20px;
			
		}
	
		.ord-price{
		
			font-size: 18px;
			font-family: Arial;
			font-weight: bold;
			color: #191919;
			line-height: 24px;
	
		}
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}
.member{
	width: 247px;
	height: 687px;
	background: #F8F8F8;
	padding: 30px;
	h5{
		line-height: 50px;
		background: url(../../assets/bot1.png) no-repeat bottom left;
	}
	.con{
		li{
			border-bottom:1px solid #eeeeee;
			padding: 20px;
		}
		h6{
			line-height: 40px;
		}
		p{
			display: flex;
			line-height: 40px;
			align-items: center;
			color: #777777;
			span{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #636363;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.act{
			color: #000000;
		}
	}

}
.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	
	flex: 1;
	margin-left: 20px;
	.ord-not{
		border: 1px solid #D2D2D2;
		padding: 20px;
		margin-bottom: 20px;
	
		.dot{
			color: #0A0A0A;
		}
	}
	.men-l1{
		border: 1px solid #D2D2D2;
		margin-bottom: 20px;
		.re-tit{
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			span{
				margin-right: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
.cen-ord1{
background: #F8F8F8;
padding: 15px;
margin-bottom: 20px;
font-weight: bold;
font-size: 15px;
}
.cen-ord2{
	width: 100%;
	height: 90px;
}
.cen-ord3{
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content:space-evenly;
}
	.page{
		text-align: center;
		margin:50px auto;
	}
	.mem-con-it{
		height: 100px;
	}
	.mem-ord-det{
		margin-top: 15px;
		text-decoration: underline;
	}
	.language-tip{
		display: flex;
		align-items: center;

		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #000000;
	

	}
</style>